import { deepReports, categoryArticles } from '@/mocks/news';

export default function DeepSection() {
  const picks = [
    deepReports[1],
    categoryArticles['行业'][0],
    categoryArticles['人物'][0],
  ];

  return (
    <section id="deep" className="scroll-mt-16 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-bold tracking-widest text-primary-700">
              <span className="h-px w-8 bg-primary-500" /> 深度报道 · 编辑精选
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              不满足于热搜的表面信息
            </h2>
          </div>
          <a
            href="#feed"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-foreground-700 hover:text-primary-700 sm:flex"
          >
            全部专题 <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 头号长文 */}
          <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-2 lg:flex-row">
            <div className="relative h-52 w-full shrink-0 overflow-hidden lg:h-auto lg:w-[46%]">
              <img
                src={deepReports[0].image}
                alt={deepReports[0].title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 whitespace-nowrap rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                {deepReports[0].tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-center p-6">
              <p className="text-xs font-medium text-foreground-600">
                {deepReports[0].time} · 预计阅读 {deepReports[0].read}
              </p>
              <h3 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                {deepReports[0].title}
              </h3>
              <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-700">
                {deepReports[0].summary}
              </p>
              <div className="mt-5 flex items-center gap-2 text-xs text-foreground-600">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                  <i className="ri-user-3-line text-xs" aria-hidden="true" />
                </span>
                {deepReports[0].author}
              </div>
            </div>
          </article>

          {/* 编辑部精选列表 */}
          <aside className="flex flex-col gap-4">
            {picks.map((a, i) => (
              <a
                key={a.id}
                href="#topics"
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 font-heading text-base font-bold text-secondary-800">
                  {i + 1}
                </span>
                <div className="flex-1">
                  <span className="text-xs font-semibold text-accent-700">{a.tag}</span>
                  <h4 className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                    {a.title}
                  </h4>
                  <p className="mt-1 text-xs text-foreground-600">
                    {a.author} · {a.read}
                  </p>
                </div>
              </a>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}